
import { app } from '@app/js/util/platform'
import sdtj from '@sdtj/util'

export default {
  data() {
    return {
      isMPSdtj: app.isMPSdtj(),
    }
  },
  methods: {
    // 所有的方法都已sdtj开头，避免命名冲突
    sdtj_ToMp(page, payload) { // 跳到小程序
      return sdtj.jumpMp(page, payload)
    },
    sdtj_PostMessage(payload) {
      return sdtj.postMessage(payload)
    },
    sdtj_Pay(payload) {
      return sdtj.toPay(payload)
    },
    sdtj_ToMap(payload) {
      return sdtj.jumpMp('map', payload)
    }
  }
}
